import { Button } from '@/components/ui/button';
import supremeCourtImage from '@/assets/supreme-court-justice.png';
import crownLogo from '@/assets/crown-logo-new.png';
import { Link } from 'react-router-dom';

const HeroDouble = () => {
  return (
    <section id="home" className="relative h-screen flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat animate-[subtle-zoom_5s_ease-out_forwards]"
        style={{ backgroundImage: `url(${supremeCourtImage})` }}
      >
        <div className="absolute inset-0 bg-primary/80"></div>
      </div>
      
      <div className="relative z-10 container mx-auto px-4 text-center text-hero-foreground flex items-center justify-center h-full">
        <div className="opacity-0 animate-fade-in" style={{ animationDelay: '0.5s', animationFillMode: 'forwards' }}>
          <p className="text-hero-foreground/70 text-base font-rockwell font-normal mb-8 opacity-0 animate-fade-in" style={{ animationDelay: '1.0s', animationFillMode: 'forwards' }}>
            We operate in state and federal courts within all 50 states of the Republic.
          </p>
          
          <Link to="/about" className="block">
            <img 
              src={crownLogo} 
              alt="Freeman & Crown Equity Law Group" 
              className="mx-auto max-h-36 md:max-h-40 max-w-xs sm:max-w-sm md:max-w-4xl w-auto object-contain cursor-pointer"
            />
          </Link>
          <div className="w-full max-w-[90vw] mx-auto mt-8 mb-8">
            <div className="h-0.5 bg-hero-foreground/50 w-0 animate-[draw-line-long_1.9s_ease-out_1.2s_forwards]"></div>
          </div>
          <blockquote className="text-hero-foreground/90 text-base sm:text-base md:text-xl font-medium font-rockwell max-w-sm sm:max-w-md md:max-w-2xl mx-auto px-2 sm:px-4">
            {['"', "Nobody", "can", "give", "you", "freedom.", "Nobody", "can", "give", "you", "equality", "or", "justice", "or", "anything.", "If", "you're", "a", "man,", "you", "take", "it.", '"'].map((word, index) => (
              <span 
                key={index} 
                className="opacity-0 animate-fade-in inline-block mr-1" 
                style={{ 
                  animationDelay: `${1 + index * 0.1}s`, 
                  animationFillMode: 'forwards' 
                }}
              >
                {word}
              </span>
            ))}
            <span className="ml-4 text-hero-foreground/70 text-base font-rockwell font-normal opacity-0 animate-fade-in" style={{ animationDelay: '3.4s', animationFillMode: 'forwards' }}>
              — Malcolm X
            </span>
          </blockquote>
        </div>
      </div>
      
      {/* Copyright line for home page */}
      <div className="absolute bottom-0 left-0 right-0 z-10 p-4">
        <div className="text-center text-sm text-hero-foreground/40 opacity-0 animate-fade-in" style={{ animationDelay: '3.8s', animationFillMode: 'forwards' }}>
          © 2025 Freeman & Crown Equity Trust. All Rights Reserved.
        </div>
      </div>
    </section>
  );
};

export default HeroDouble;